import React from 'react';
import { Button } from '@indeed/ifl-components';
import GlobalNavBarView from 'ReactCommon/GlobalNavBarView';
import { getPassportURL } from 'Utils/PassportUtil';
import HeaderContent from './_HeaderContent';
import './Header.scss';
const Header = (props) => {
    return (React.createElement(GlobalNavBarView, { appHomeUrl: "#/home", myPageUrl: "#/mypage", profileUrl: "#/profile", isLoggedIn: window.passportInfo.isLoggedIn, loginUrl: getPassportURL('login', 'navbar'), headerContent: React.createElement(HeaderContent, { ...props, isGlobalNavBar: true }), customRightButton: props.type === 'camera' ? (React.createElement(Button, { variant: "text", onClick: props.onClickCancel, className: "Header-cancelButton" }, "\u30AD\u30E3\u30F3\u30BB\u30EB")) : (props.customRightButton), selectedButton: props.selectedButton }));
};
export default Header;
